import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { QuoteDataCaptureService, ModalScroll } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import moment from 'moment';

import { Subscription } from 'rxjs';
import { RangeValidationConfig } from 'src/app/model/rangeValidation.model';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss'],
    providers: [
        {
            provide: NG_VALIDATORS, useExisting: DateInputComponent, multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateInputComponent),
            multi: true
        }
    ],
    imports: [ReactiveFormsModule, NgClass]
})
export class DateInputComponent implements OnInit, Validators, ControlValueAccessor {
  constructor(public router: Router,
    private fb: UntypedFormBuilder,
    
    private route: ActivatedRoute,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private store: Store<AppState>, private btnFocusOnModalClose: ModalScroll) {
    this.contentData = this.route.snapshot.data.contentData;
    this.maxYears = +this.contentData.dateInput.maxYears;
    store.select(STORE_VAL.personal_details).subscribe(res => {
      if (res.length > 0) {
        this.personalDetailStoreData = res[0];
      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetails = res[0];
      }
    });
  }
  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() tooltipData: Tooltip;
  @Input() pageName: string;
  @Input() minAge: string;
  @Input() allowFutureData: boolean = false;
  @Input() commencementDateConfigObj: RangeValidationConfig;
  @Input() startDateAgeRangeConfigObj: RangeValidationConfig;
  
  // tslint:disable-next-line:no-output-on-prefix
  @Output() blurHandler: EventEmitter<any> = new EventEmitter<any>();
  public textValue: string;
  dobSelected;
  disabled: boolean;
  contentData;
  maxlength: string;
  public maxYears: number;
  public flagArray: Array<boolean> = [false, false];
  private subscriptn: Subscription;

  personalDetailStoreData: any;
  loginDetails: any;


  onTouched: () => void;

  onChange = (value: string) => { };
  ngOnInit() {
    if(this.parent.get(['dateOfBirth'])){
      this.textValue = this.parent.get(['dateOfBirth']).value;
    }
    else{
      this.textValue = "";
    }
    this.setValue();
  }

  ngOndestroy() {
    this.subscriptn.unsubscribe();
  }

  writeValue(value: any): void {
    this.controllerData.value = value ? value : null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate() {
    // tslint:disable-next-line:max-line-length
    const nameReForDOB: RegExp = /^(((0[1-9]|[12]\d|3[01])\s\/\s(0[13578]|1[02])\s\/\s(((19|[2-9]\d)|(18|[2-9]\d))\d{2}))|((0[1-9]|[12]\d|30)\s\/\s(0[13456789]|1[012])\s\/\s(((19|[2-9]\d)|(18|[2-9]\d))\d{2}))|((0[1-9]|1\d|2[0-8])\s\/\s02\s\/\s(((19|[2-9]\d)|(18|[2-9]\d))\d{2}))|(29\s\/\s02\s\/\s((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
    let validFormat = true;
    if (this.parent.get(this.controllerData.controlName).value) {
      validFormat = this.checkDateFormat(this.parent.get(this.controllerData.controlName).value);
    }
    if (validFormat) {
      let disableFutureDates = false;
      let forbidden = nameReForDOB.test(this.parent.get(this.controllerData.controlName).value);
      if (forbidden && this.parent.get(this.controllerData.controlName).value) {
        const currentDate = new Date();
        const dateString = this.parent.get(this.controllerData.controlName).value;
        const dateParts = dateString.split(' / ');
        const dobDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        if (this.allowFutureData) {
          forbidden = true;
          disableFutureDates = false;
        } else if (dobDate > currentDate) {
          forbidden = false;
          disableFutureDates = true;
        }
        if (this.parent.get(this.controllerData.controlName).value && disableFutureDates === false) {
          const minAgeString = (this.minAge && this.minAge.indexOf('.') > -1 ?
            this.minAge.split('.') : +this.minAge);
          const minAgeYears = +minAgeString[0] || null;
          const minAgeMonths = +minAgeString[1] || null;
          const intervalYear: moment.unitOfTime.DurationConstructor = 'years';
          const intervalMonth: moment.unitOfTime.DurationConstructor = 'months';
          const intervalDay: moment.unitOfTime.DurationConstructor = 'days';
          const intervals = [intervalYear, intervalMonth, intervalDay];
          const out = [];
          const todaysDate = moment(currentDate);
          const birthDate = moment(dobDate);
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < intervals.length; i++) {
            const diff = todaysDate.diff(birthDate, intervals[i]);
            birthDate.add(diff, intervals[i]);
            out.push(diff);
          }
          if (minAgeYears && minAgeMonths) {
            switch (true) {
              case out[0] < minAgeYears:
                this.flagArray[0] = true;
                forbidden = false;
                break;
              case out[0] > this.maxYears:
                this.flagArray[0] = true;
                forbidden = false;
                break;
              case out[0] === minAgeYears:
                if (out[1] < minAgeMonths) {
                  this.flagArray[0] = true;
                  forbidden = false;
                }
                break;
              case out[0] === this.maxYears:
                if (out[1] !== 0 || out[2] !== 0) {
                  this.flagArray[0] = true;
                  forbidden = false;
                }
                break;
              default: break;
            }

          } else if (minAgeString) {

            switch (true) {
              case out[0] < minAgeString:
                this.flagArray[1] = true;
                forbidden = false;
                break;

              case out[0] > this.maxYears:
                this.flagArray[1] = true;
                forbidden = false;
                break;

              case out[0] === this.maxYears:
                if (out[1] !== 0 || out[2] !== 0) {
                  this.flagArray[1] = true;
                  forbidden = false;
                }
                break;
              default: break;
            }
          }
        }

      }
      if (this.parent.get(this.controllerData.controlName).value) {
        if (this.flagArray[0] === true || this.flagArray[1] === true) {
          this.blurHandler.emit(this.flagArray);
          this.flagArray = [false, false];
        }
        // DTC-3649 : defect# 3048
        if (this.controllerData.controlName === 'startDate' && this.allowFutureData) {
          const startDateVal = this.parent.get(this.controllerData.controlName).value;
          const splitStartDate = startDateVal.split('/');
          this.blurHandler.emit([true, false]);
          if (this.ageCheck()) {
            return { invalidAge: true };
          }
          // tslint:disable-next-line:max-line-length
          if (((new Date(splitStartDate[1] + '/' + splitStartDate[0] + '/' + splitStartDate[2]).getTime()) < (new Date().setHours(0, 0, 0, 0))) || (new Date(splitStartDate[1] + '/' + splitStartDate[0] + '/' + splitStartDate[2]) > new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 90)))) {
            /* checking whether the value entered is within 3 months of today\'s date')*/
            return { threeMonthsValid: true };
          }
        }
        return forbidden ? null : { dobIsNotValid: true };
        // tslint:disable-next-line:align
      } return null;
    } else {
      return { dobFormatInvalid: true };
    }
  }


  private setValue(): void {
    if (this.controllerData.required) {
      this.parent.get(this.controllerData.controlName).setValidators([Validators.required]);
    } else {
      this.parent.get(this.controllerData.controlName).clearValidators();
    }
    this.parent.get(this.controllerData.controlName).setValue(this.controllerData.value);
  }
  addslash(data, event) {
    if (
      (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
      (event.keyCode < 96 || event.keyCode > 105) && event.keyCode !== 8 && event.keyCode !== 9
      && event.keyCode !== 46 && event.keyCode !== 32 && event.keyCode !== 37 && event.keyCode !== 39
    ) {
      event.preventDefault();
    } else {
      const inputLength = data.toString().length + 1;
      if (event.keyCode !== 8) {
        if (inputLength === 2 || inputLength === 7) {
          data = data.toString() + parseInt(event.key) + ' / ';
          const thisVal = data;
          this.parent.get(this.controllerData.controlName).setValue(thisVal);

          event.preventDefault();
        }
      }
    }
  }

  validateInput = () => {
    this.blurHandler.emit(this.flagArray);
  }

  checkDateFormat = (date) => {
    let valid = false;
    date = date.toString().replace(/ /g, '');
    const dateArr = date.toString().split('/');
    if (dateArr.length !== 3) {
      return valid;
    }
    if (dateArr.length > 0 && dateArr[0].toString().length !== 2) {
      return valid;
    }
    if (dateArr.length > 1 && dateArr[1].toString().length !== 2) {
      return valid;
    }
    if (dateArr.length > 2 && dateArr[2].toString().length !== 4) {
      return valid;
    }
    valid = true;
    return valid;
  }

  /* defect 3388 : DTC-3649_An errror Message must be display when user selecting under 55 years at Start date. */
  ageCheck() {
    if (this.parent.get(this.controllerData.controlName)
      && this.parent.get(this.controllerData.controlName).value) {
      const date1 = this.parent.get(this.controllerData.controlName).value.split(' / ');
      const quoteDate = new Date(+date1[2], date1[1] - 1, +date1[0]);
      const dateParts = this.loginDetails ? this.personalDetailStoreData.dateOfBirth.split('/')
        : this.personalDetailStoreData.dateOfBirth.split(' / ');
      const dobDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      const intervalYear: moment.unitOfTime.DurationConstructor = 'years';
      const intervalMonth: moment.unitOfTime.DurationConstructor = 'months';
      const intervalDay: moment.unitOfTime.DurationConstructor = 'days';
      const intervals = [intervalYear, intervalMonth, intervalDay];
      const out = [];
      const todaysDate = moment(quoteDate);
      const birthDate = moment(dobDate);
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < intervals.length; i++) {
        const diff = todaysDate.diff(birthDate, intervals[i]);
        birthDate.add(diff, intervals[i]);
        out.push(diff);
      }
      if (out[0] < 55) {
        return true;
      } else {
        return false;
      }
    }

  }

  dateReformat(eventValue) {
    let input = eventValue.replace(/\D/g, '');
    if (input.length === 8) {
      let formattedDate = input.slice(0, 2) + ' / ' + input.slice(2, 4) + ' / '
        + input.slice(4);
      this.parent.get(this.controllerData.controlName).setValue(formattedDate);

    }
  }
}
